module.exports = __webpack_public_path__ + "img/head_left.e2ae8d21.png";